import React, { useState } from "react";
import {
  Button,
  Divider,
  FormFieldSet,
  InfoText,
  KeyValue,
  PageHeader,
  PageTitle,
  StatusTags,
  useFormHandler,
} from "../../../../../components";
import H1BViewTabs from "./H1BViewTabs";

const H1BView = ({ employee, onBack }) => {
  const [isEdit, setIsEdit] = useState(true);

  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      h1bStatus: "",
      employeeType: "Employee",
      employeeName: "",
      employeeFirstName: "",
      employeeMiddleName: "",
      employeeLastName: "",
      receiptNumber: "",
      filedOn: "",
      approvedDate: "",
      approvedFrom: "",
      approvedUntil: "",
      processingType: "Premium",
      basisOfH1B: "",
      lcas: "",
      priority: "",
      recordStatus: "",
      comments: "",
    },
    {
      h1bStatus: { type: "select", required: true },
    },
  );
  return (
    <div className="overflow-auto">
      <div className="mt-3">
        <PageHeader
          Section={
            <div>
              <PageHeader
                Section={
                  <div className="flex">
                    <Button
                      className="pl-0!"
                      // type="icon"
                      variant="text"
                      color="black"
                      icon={"arrow_left_alt"}
                      onClick={onBack}
                      title={"View H-1B"}
                    />
                    {/* <PageTitle title={"View H-1B"} tag="h6" /> */}
                  </div>
                }
                RightSection={
                  <>
                    <Button title="Visa Status" size="sm" />
                    <Button
                      title="Edit"
                      size="sm"
                      onClick={() => setIsEdit(false)}
                    />
                    <Button
                      type="icon"
                      variant="text"
                      color="black"
                      icon={"history"}
                    />
                  </>
                }
              />
            </div>
          }
        />
      </div>
      <div className="border-[1px] border-neutrals-50 p-3 mt-3 rounded-sm">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"PETITION DETAILS"} tag="h6" />
            </div>
          }
          RightSection={
            <>
              <PageTitle title={`H-1B ID: H1B171`} tag="P" />
            </>
          }
        />
        <Divider />
        <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 mt-8 gap-x-8 gap-y-6">
          <FormFieldSet
            type="select"
            title={"H-1B Status"}
            placeholder="Enter Last Name"
            value={formData.h1bStatus}
            onChange={(value) => handleChange("h1bStatus", value)}
            error={errors.h1bStatus}
            disabled={isEdit}
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 mt-8 gap-x-8 gap-y-6">
          <FormFieldSet
            type="radio"
            title={"Employee Type"}
            options={[
              { label: "Employee", value: "Employee" },
              {
                label: "Prospective Employee",
                value: "Prospective Employee",
              },
            ]}
            value={formData.employeeType}
            onChange={(event) =>
              handleChange("employeeType", event.target.value)
            }
            name="Employee Type"
            disabled={isEdit}
          />

          <FormFieldSet
            type="select"
            title={"Employee Name"}
            placeholder="Enter Last Name"
            value={formData.employeeName}
            onChange={(value) => handleChange("employeeName", value)}
            error={errors.employeeName}
            disabled={isEdit}
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 mt-8 gap-x-8 gap-y-6">
          <FormFieldSet
            type="select"
            title={"Employee First Name"}
            placeholder="Select Employee First Name"
            value={formData.employeeFirstName}
            onChange={(value) => handleChange("employeeFirstName", value)}
            error={errors.employeeFirstName}
            disabled={isEdit}
          />

          <FormFieldSet
            type="select"
            title={"Employee Middle Name"}
            placeholder="Select Employee Middle Name"
            value={formData.employeeMiddleName}
            onChange={(value) => handleChange("employeeMiddleName", value)}
            error={errors.employeeMiddleName}
            disabled={isEdit}
          />

          <FormFieldSet
            type="select"
            title={"Employee Last Name"}
            placeholder="Select Employee Last Name"
            value={formData.employeeLastName}
            onChange={(value) => handleChange("employeeLastName", value)}
            error={errors.employeeLastName}
            disabled={isEdit}
          />

          <FormFieldSet
            type="select"
            title={"Receipt Number"}
            placeholder="Enter Last Name"
            value={formData.lastName}
            onChange={(value) => handleChange("lastName", value)}
            error={errors.lastName}
            disabled={isEdit}
          />

          <FormFieldSet
            type="datepicker"
            title={"Filed On"}
            placeholder="Select Filed On"
            value={formData.filedOn}
            onChange={(value) => handleChange("filedOn", value)}
            error={errors.filedOn}
            disabled={isEdit}
            showDropdown={false}
          />

          <FormFieldSet
            type="datepicker"
            title={"Approved Date"}
            placeholder="Select Approved Date"
            value={formData.approvedDate}
            onChange={(value) => handleChange("approvedDate", value)}
            error={errors.approvedDate}
            disabled={isEdit}
            showDropdown={false}
          />

          <FormFieldSet
            type="datepicker"
            title={"Approved From"}
            placeholder="Select Approved From"
            value={formData.approvedFrom}
            onChange={(value) => handleChange("approvedFrom", value)}
            error={errors.approvedFrom}
            disabled={isEdit}
            showDropdown={false}
          />

          <FormFieldSet
            type="datepicker"
            title={"Approved Until"}
            placeholder="Select Approved Until"
            value={formData.approvedUntil}
            onChange={(value) => handleChange("approvedUntil", value)}
            error={errors.approvedUntil}
            disabled={isEdit}
            showDropdown={false}
          />

          <FormFieldSet
            type="radio"
            title={"Processing Type"}
            options={[
              { label: "Premium", value: "Premium" },
              {
                label: "Normal",
                value: "Normal",
              },
            ]}
            value={formData.processingType}
            onChange={(event) =>
              handleChange("processingType", event.target.value)
            }
            name="Processing Type"
            disabled={isEdit}
          />

          <FormFieldSet
            type="select"
            title={"Basis of H-1B"}
            placeholder="Select Basis of H-1B"
            value={formData.basisOfH1B}
            onChange={(value) => handleChange("basisOfH1B", value)}
            error={errors.basisOfH1B}
            disabled={isEdit}
          />

          <FormFieldSet
            type="select"
            title={"LCA(s)"}
            placeholder="Select LCA(s)"
            value={formData.lcas}
            onChange={(value) => handleChange("lcas", value)}
            error={errors.lcas}
            disabled={isEdit}
          />

          <FormFieldSet
            type="select"
            title={"Priority"}
            placeholder="Select Priority"
            value={formData.priority}
            onChange={(value) => handleChange("priority", value)}
            error={errors.priority}
            disabled={isEdit}
          />

          <FormFieldSet
            type="select"
            title={"Record Status"}
            placeholder="Select Record Status"
            value={formData.recordStatus}
            onChange={(value) => handleChange("recordStatus", value)}
            error={errors.recordStatus}
            disabled={isEdit}
          />

          <FormFieldSet
            type="textArea"
            title={"Comments"}
            placeholder="Enter Comments"
            value={formData.comments}
            onChange={(value) => handleChange("comments", value)}
            error={errors.comments}
            disabled={isEdit}
          />
        </div>

        <div className="flex mt-6 justify-between items-end md:gap-2">
          <div className="bg-primary-50 rounded-sm p-6 max-w-xl  flex-1">
            <div className="flex justify-between">
              <div>
                <InfoText
                  title={"LCA: I-200-24142-019530"}
                  value={"11/19/2024 - 11/18/2027"}
                />
              </div>
              <div>
                <StatusTags tag="Active" />
              </div>
            </div>
            <div className="mt-4 flex flex-col gap-3">
              <KeyValue label={"Job Title"} value={"Business Analyst"} />
              <KeyValue
                label={""}
                value={
                  "3 University Plaza Dr, Hackensack, New Jersey, United States"
                }
              />
            </div>
            <div className="flex">
              <Button
                type="link"
                icon={"download"}
                title={"Paper LCA: I-200-24142-019530.pdf"}
                variant="text"
                iconPosition="after"
                color="info"
                className="pl-0"
              />
            </div>
          </div>
          <div className="justify-end md:ml-3">
            <Button title="save" />
          </div>
        </div>

        <div className="my-4">
          <H1BViewTabs />
        </div>
      </div>
    </div>
  );
};

export default H1BView;
